export const DATE_FORMAT_NORMAL = 'yyyy/MM/dd' as const
export const DATE_FORMAT_JA = 'yyyy年MM月dd日' as const
export const DATETIME_FORMAT_JA = 'yyyy年MM月dd日(E) HH:mm' as const
export const DATE_FORMAT_JA_WITH_DAY_OF_WEEK = 'yyyy年M月d日(E)' as const
export const DATETIME_FORMAT = 'yyyy/MM/dd HH:mm' as const
export const TIME_FORMAT = 'HH:mm' as const

/**
 * 日付ではなくリテラルとして出力するフォーマット
 * @description date-fns はシングルクォートで囲んだ範囲をエスケープしてリテラル出力する。
 *              クォートが外れると日付として解釈され、画面に意図しない日付が出てしまうため定数化している
 */
export const DATE_FORMAT_LITERAL_YESTERDAY = "'昨日'" as const
export const DATE_FORMAT_LITERAL_DAY_BEFORE_YESTERDAY = "'一昨日'" as const
